import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';

/**
 * La carte d'état de service, seul contenu propre de l'ancienne
 * « Vue d'ensemble » (`overviewContent`, `entityShared.tsx`).
 *
 * Elle devient une `EntityCardBlueprint` de type `content` : le catalogue natif
 * la place dans l'onglet de vue d'ensemble, aux côtés des cartes qu'il fournit
 * lui-même. L'onglet n'appartient donc plus à personne en particulier — c'est
 * ce que la spec décrit, chaque domaine y déposant sa carte.
 *
 * `entityWarningContent` (orphelin, erreurs de traitement, avertissements de
 * relations) ne migre PAS ici : ces trois panneaux viennent de
 * `@backstage/plugin-catalog`, qui les expose déjà comme extensions dans sa
 * version nouveau système. Les réécrire serait dupliquer l'amont.
 */
const isComponent = (entity: Entity): boolean =>
  entity.kind?.toLowerCase() === 'component';

const serviceStatusCard = EntityCardBlueprint.make({
  name: 'service-status',
  params: {
    type: 'content',
    filter: isComponent,
    loader: () =>
      import('./ServiceStatusCard').then(m => <m.ServiceStatusCard />),
  },
});

export default createFrontendPlugin({
  pluginId: 'service-status',
  extensions: [serviceStatusCard],
});
